<template>
  <div class="c-personal-wrapper">
    <!-- filter -->
    <calc-filter
      slot="filter"
      :game-data="gameData"
      @on-add="visible = true"
      @on-down="downExcel"
      @on-import="importExcel"
      @on-change="filterData"
    />

    <!-- table  -->
    <Viewport v-model="tableHeight">
      <el-table class="common-el-table-styles" :data="tableData" :height="tableHeight" v-loading="loading">
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <div v-if="col.key === 'control'" class="m-control">
              <Poptip confirm transfer title="您确认删除该回款计算器吗？" @on-ok="delClick(scope.row)">
                <el-button type="text">删除</el-button>
              </Poptip>
              <el-button type="text" @click="editClick(scope.row)">修改</el-button>
            </div>
            <span v-else-if="col.key === 'androidStandard'">{{ scope.row[col.key] | toPercent }}</span>
            <span v-else-if="col.key === 'iosStandard'">{{ scope.row[col.key] | toPercent }}</span>
            <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else-if="col.key === 'upTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>

    <resulter
      v-model="resultModel"
      type="回款计算器"
      :add-total="added"
      :update-total="updated"
      :fail-total="failure"
      :table-data="success_d"
      @on-close="resultOk"
    />

    <Modal
      v-model="visible"
      :title="title"
      :width="520"
      :mask-closable="false"
      class-name="vertical-center-modal"
      @on-visible-change="bindGetData"
    >
      <div class="m-form">
        <Form :label-width="140">
          <FormItem label="天数" prop="dayNum">
            <Input v-model="calc.dayNum" :disabled="editble" placeholder="请输入天数" style="width: 180px" />
          </FormItem>
          <FormItem label="中间件游戏" prop="mGameId">
            <auto-complete
              v-model="calc.mGameId"
              :data="gameData"
              :disabled="editble"
              :popper-append-to-body="false"
              placeholder="请选择游戏"
              @on-select="handleGame"
            />
          </FormItem>
          <FormItem label="安卓合格标准" prop="androidStandard">
            <InputNumber
              v-model="calc.androidStandard"
              :precision="2"
              :min="0"
              :max="100"
              :formatter="(value) => `${value}%`"
              :parser="(value) => value.replace('%', '')"
            />
          </FormItem>
          <FormItem label="iOS合格标准" prop="iosStandard">
            <InputNumber
              v-model="calc.iosStandard"
              :precision="2"
              :min="0"
              :max="100"
              :formatter="(value) => `${value}%`"
              :parser="(value) => value.replace('%', '')"
            />
          </FormItem>
        </Form>
      </div>
      <template slot="footer">
        <div class="m-foot">
          <Button @click="visible = false">取消</Button>
          <Button type="primary" :loading="saving" @click="handleSubmit">
            <span v-if="saving">提交中...</span>
            <span v-else>确认</span>
          </Button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { isArray, isEmpty, timeout } from '@/common/js/utils'
import { div, mul } from '@/common/js/api'
import { HOST_API } from '@/api/config'
import CalcFilter from './components/calc-filter'
import Resulter from '@/components/export/result-dialog'
import AutoComplete from '@/components/autocomplete/autocomplete'
import tableMixin from '../designerkpi/mixin_table'
import tableColumns from '../data/calculator_columns'

import { getCalculatorPage, addCalculator, getCalculatorDetail, delCalculatorById, importCalcPayBackExcel } from '@/api/team.model'
import { getMiddleGameList } from '@/api/common.model'

export default {
  name: 'Calculator',
  mixins: [tableMixin],
  components: {
    AutoComplete,
    Resulter,
    CalcFilter
  },
  computed: {
    title() {
      return this.editble ? '修改回款计算器' : '新增回款计算器'
    }
  },
  data() {
    return {
      tableHeight: 330,
      tableData: [],
      tableColumns: [],
      gameData: [],

      loading: null,
      saving: null,
      visible: null,
      editble: null,
      calc: {
        mGameId: '',
        androidStandard: 0,
        iosStandard: 0
      },
      resultModel: null,
      success_d: [],
      added: 0,
      failure: 0,
      updated: 0
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.editble = val
        timeout(300).then(() => {
          this.calc = { mGameId: '', androidStandard: 0, iosStandard: 0 }
        })
      }
    },
    importExcel(file) {
      this.$Spin.show()
      importCalcPayBackExcel({ file }).then((data) => {
        this.$Spin.hide()
        if (data && isArray(data.list)) {
          this.resultModel = true
          this.added = data.addTotal
          this.failure = data.failTotal
          this.updated = data.updateTotal
          this.success_d = data.list.map((ret) => {
            return {
              row_line: Object.keys(ret)[0],
              msg: ret[Object.keys(ret)[0]]
            }
          })
        }
      })
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_payback`, '_blank')
    },
    resultOk() {
      this.resultModel = false
      this.pageIndex = 1
      this.getData()
    },
    delClick({ dayNum, mGameId }) {
      delCalculatorById({ dayNum, mGameId }).then((data) => {
        data && this.getData()
      })
    },
    editClick({ dayNum, mGameId }) {
      getCalculatorDetail({ dayNum, mGameId }).then((data) => {
        if (data) {
          const { dayNum, mGameId, androidStandard, iosStandard } = data
          this.calc = { dayNum, mGameId, androidStandard: mul(androidStandard, 100), iosStandard: mul(iosStandard, 100) }
          this.visible = true
          this.editble = true
        }
      })
    },
    handleGame(meta) {
      this.$set(this.calc, 'mGameId', meta.id)
    },
    handleSubmit() {
      let { dayNum, mGameId, androidStandard, iosStandard } = this.calc
      if (isEmpty(dayNum)) {
        this.$Message.error('天数不能为空！')
        return
      }
      if (isEmpty(mGameId) || !mGameId) {
        this.$Message.error('中间件游戏不能为空！')
        return
      }
      if (!androidStandard || !iosStandard) {
        this.$Message.error('合格标准值不能为空或小于等于 0 ！')
        return
      }
      androidStandard = div(androidStandard, 100)
      iosStandard = div(iosStandard, 100)
      addCalculator({ dayNum, mGameId, androidStandard, iosStandard, editble: this.editble }).then((data) => {
        data && (this.visible = false)
        data && this.getData()
      })
    },
    getData(filter) {
      let params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getCalculatorPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = tableColumns
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    preloadData() {
      Promise.all([getMiddleGameList()]).then((data) => {
        const [gameData] = data
        isArray(gameData) && (this.gameData = gameData)
        isArray(gameData) && this.getData({})
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-personal-wrapper {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
